var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"alreadyQuoted"}},[_c('van-nav-bar',{attrs:{"title":"订单详情","left-arrow":"","border":false},on:{"click-left":function($event){return _vm.goSubPage('home')}}}),_c('ProductInfor',{attrs:{"needButton":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }